import React from "react";
import BigNumber from "bignumber.js";
import {useStakingContract, useStakingDispatch} from "../../context/StakingContract";
import StakingContract from "../../context/StakingContract/StakingContract";
import {
  SET_ADDEES_NOT_STAKED, SET_CONNECTED_ADDRESS, SET_ERD_BALANCE,
  SET_ERD_BALANCE_BOOL,
  SET_ETH_BALANCE_BOOL, SET_EXISTING_ALLOWANCE,
  SET_METAMASK, SET_STAKING_VALUE, SET_TOTAL_STAKE, SET_TOTAL_STAKE_LIMIT, SHOW_STAKE
} from "../../context/StakingContract/actions";

const Prerequisites = (props) => {
  const { nextStep } = props;
  const {stakingContract, state} = useStakingContract();
  const dispatch = useStakingDispatch();


  const thisWorks = () => {
    dispatch({type: SET_METAMASK, payload: true});

    stakingContract.contractTotalStakeLimit()
      .then(val => dispatch({type: SET_TOTAL_STAKE_LIMIT, payload: val}))
      .catch(err => {
        console.warn("error fetching total staking limit", err);
      });
    stakingContract.currentTotalStake()
      .then(val => {
        dispatch({type: SET_TOTAL_STAKE, payload: val})
      })
      .catch(err => {
        console.warn("error fetching total stake", err);
      });

    // 4. Check if connected account has ERD and ETH balances
    stakingContract.provider.getSigner().getAddress().then(addr => {
      dispatch({type: SET_CONNECTED_ADDRESS, payload: addr});

      stakingContract.ethBalance().then(ethBalance => {
        if ( ethBalance > new BigNumber(0) ) {
          dispatch({type: SET_ETH_BALANCE_BOOL, payload: true})
        } else {
          console.log("smaller ETH balance");
        }
      }).catch(e => console.error(e));

      stakingContract.erdBalance().then(erdBalance => {
        if ( erdBalance > new BigNumber(0) ) {
          dispatch({type: SET_ERD_BALANCE_BOOL, payload: true});
          dispatch({type: SET_ERD_BALANCE, payload: erdBalance});
          dispatch({type: SET_STAKING_VALUE, payload: erdBalance});
        } else {
          console.log("smaller ERD balance");
        }
      }).catch(e => console.error(e));

      // Check if address is already staked:
      stakingContract.alreadyStaked().then(staked => {
        dispatch({type: SET_ADDEES_NOT_STAKED, payload: !staked});
        if ( staked ) {
          return;
        }

        stakingContract.getAllowance().then(allowance => {
          if ( allowance > 0 ) {
            dispatch({type: SET_EXISTING_ALLOWANCE, payload: allowance});
          }
        }).catch(e => console.error(e));
      }).catch(e => console.error(e));
    });
  };

  const checkPrerequisites = () => {
    dispatch({type: SHOW_STAKE, payload: false});
    // 1. Check metamask installed!
    if ( !StakingContract.hasMetamask() ) {
      console.log("user does not have metamask installed");
      return;
    }
    console.log("user has metamask installed");

    // 2. Check if metamask is unlocked
    stakingContract.metamaskEnabled().then(isEnabled => {
      // 3. Enable metamask
      if ( !isEnabled ) {
        // This will show metamask popup
        StakingContract.enableMetamask()
          .then(_ => {
            thisWorks();
          })
          .catch(e => {
            console.warn("user rejected metamask");
          });
          return;
      }
      thisWorks();
    });
  };

  React.useEffect(checkPrerequisites, []);

  const {prerequisites, staking} = state;
  const canGoToTheNextStep = prerequisites.erdBalance && prerequisites.ethBalance && prerequisites.metamask && prerequisites.addressNotStaked;
  const nextStepValidation = canGoToTheNextStep ? nextStep : () => false;
  return (
    <div className="card">
      <div className="card-body">
        <h3>Prerequisites</h3>
        <p className="lead">In order to move to the next step, we are automatically checking that the following conditions are met:</p>

        <ul className="prerequisites mb-4">
          <li>
            <span className={prerequisites.metamask ? '' : 'd-none'}>
              <em className="text-success">✓</em>
              MetaMask installed
            </span>
            <span className={prerequisites.metamask ? 'd-none' : ''}>
              <em className="text-danger">✗</em>
              MetaMask not installed
            </span>
          </li>
          <li>
            <em className={prerequisites.erdBalance ? 'text-success' : 'd-none'}>✓</em>
            <em className={prerequisites.erdBalance ? 'd-none' : 'text-danger'}>✗</em>
            ERD balance {staking.erdBalance.toLocaleString('en')}
          </li>
          <li>
            <span className={prerequisites.ethBalance ? '' : 'd-none'}>
              <em className="text-success">✓</em>
              ETH balance greater than 0 <small>(only required for gas fees)</small>
            </span>
            <span className={prerequisites.ethBalance ? 'd-none' : ''}>
              <em className="text-danger">✗</em>
              ETH balance is 0 <small>(only required for gas fees)</small>
            </span>
          </li>
          <li>
            <span className={prerequisites.addressNotStaked ? '' : 'd-none'}>
              <em className="text-success">✓</em>
              Address not already used to stake
            </span>
            <span className={prerequisites.addressNotStaked ? 'd-none' : ''}>
              <em className="text-danger">✗</em>
              Address was already used to stake
            </span>
          </li>
        </ul>
        <button className={`btn btn-primary ${canGoToTheNextStep ? '' : 'disabled'}`} onClick={nextStepValidation}>
          Continue
        </button>
      </div>
    </div>
  )
};

export default Prerequisites;
